// Jquery
require('webpack-jquery-ui/autocomplete')
$(document).ready( function() {
// remove href from the first <a> of the .withsub menu
  $('.withsub > a:first-child').removeAttr('href');

    // Burger Menu
    $('#burger-menu').click(function() {
	  $(this).toggleClass('close');
	  $('#menu').toggleClass('showmenu');
	});

  // Langswitch
  $('.current-lang').click(function() {
    $('.language-list').toggle();
  });

  $(document).click(function(event) {
    if(!$(event.target).closest('.language-switch').length) {
      if($('.language-list').is(":visible")) {
        $('.language-list').hide();
      }
    }
  });


  // Show popup
	var flashInfoShown = false;
  $(window).scroll(function() {
    if (!flashInfoShown && $(this).scrollTop() >= $('.marketingtools').offset().top) {
      $('.flashinfo').addClass('show');
      flashInfoShown = true;
    }
  });

	$('.closeflashinfo').click(function() {
	  $('.flashinfo').removeClass('show');
	});


// Search suggestions
const searchInput = $('#search-input');
const suggestionContainer = $('#suggestion-container');
const searchForm = $('#search-form');


searchInput.on('input', function() {
    const query = searchInput.val().trim();
    if (query.length >= 2) {
		fetch($('form#search').attr('action') + '?term=' + query, {
			method: "GET",
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				"Accept": "application/json",
			},
		})
			.then(response => response.json())
			.then(data => {
				const suggestionsHtml = "<ul>" + data.map(item => {
					return `<li><a href="${item.url}">
							<span>${item.label}
							 	${ item.voters_count ? `<small> ${item.voters_count}  ${item.voters}</small>` : `` }
							</span>
							<i data-star="${item.note}"></i>
						</a></li>`;
				}).join('') + "</ul>";
				suggestionContainer.find('ul').remove(); // remove any existing ul element
				suggestionContainer.find('.ajoutermarque').before(suggestionsHtml);
				suggestionContainer.css('display', 'block');
			})
    } else {
      suggestionContainer.css('display', 'none');
    }
});

suggestionContainer.on('click', 'li', function() {
  const suggestionText = $(this).find('span').html().replace(/<small>(.*?)<\/small>/g, '');
  searchInput.val(suggestionText.trim());
  suggestionContainer.css('display', 'none');
});

$(document).on('click', function(event) {
  if (!searchInput.is(event.target) && !suggestionContainer.is(event.target) && suggestionContainer.has(event.target).length === 0) {
    suggestionContainer.css('display', 'none');
  }
});



// Showing submenu also on click
	$('.withsub a:first-child').click(function() {
	  $('.withsub a:first-child').not($(this)).parent().children('ul:first').removeClass('showsub');
	  $(this).parent().children('ul:first').toggleClass('showsub');
	});

	// Slider
	$('.keyslide').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: true,
	  asNavFor: '.keypoints'
	});
	$('.keypoints').slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  asNavFor: '.keyslide',
	  dots: false,
	  arrows: false,
	  centerMode: true,
	  centerPadding: '0px',
	  focusOnSelect: true,
	  responsive: [
	    {
	      breakpoint: 900,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	  ]
	});

	$('.seclist').slick({
	  responsive: [
	    {
	         breakpoint: 9999,
	         settings: "unslick"
	      },
	      {
	         breakpoint: 768,
	           settings: {
	               centerMode: true,
	               autoplay: true,
			   centerPadding: '40px',
			   slidesToShow: 1
	             }
	      }
	   ]
	});

    $('.carousel-track').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        arrows : false,
        infinite: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1124,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 924,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

	});
